module.exports = __webpack_public_path__ + "img/what-is-rpc-1.2d6c8e90.png";